<template>
    <div :class="repeaterClass">
        <section v-for="(repeat, index) in repeats" :key="index" class="form-repeater__group">
            <header v-if="index" class="form-repeater__header">
                <h4 class="form-repeater__heading">
                    <slot name="heading" :data="repeat" :index="index">
                        {{ heading }}
                    </slot>
                </h4>

                <button
                    v-if="remove && index >= showRemoveFromIndex"
                    class="form-repeater__button"
                    type="button"
                    @click="emitEvent({ name: 'remove', payload: index })"
                >
                    {{ remove }}
                    <common-icon name="close" size="tiny"></common-icon>
                </button>
            </header>

            <slot :data="repeat" :index="index"></slot>
        </section>

        <footer v-if="!isDisabled" class="form-repeater__footer">
            <button class="form-repeater__button" type="button" @click="emitEvent({ name: 'add' })">+ {{ add }}</button>

            <small v-if="hint" class="form-repeater__hint">
                {{ hint }}
            </small>
        </footer>
    </div>
</template>

<script>
    import FormDisableableMixin from 'mixins/FormDisableableMixin'

    export default {
        mixins: [FormDisableableMixin],

        props: {
            repeats: { type: Array, required: true },
            heading: { type: String, default: undefined },
            add: { type: String, default: undefined },
            hint: { type: String, default: undefined },
            remove: { type: String, default: undefined },
            showRemoveFromIndex: { type: Number, default: 0 },
            addRepeatLabel: { type: String, default: undefined },
        },

        computed: {
            repeaterClass() {
                return {
                    'form-repeater': true,
                }
            },
        },
    }
</script>
